import { TextField } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Autocomplete from "@material-ui/lab/Autocomplete";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import Title from "../Components/Title";
import { showPopupSnackbar } from "../redux/actions/snackbarActions";
import { getToken } from "../Utils/Common";
import EnvSettings from "../Utils/EnvSettings";

const server = EnvSettings.server;

const getNumberOfSensors = (data, nos) => {
  if (data) {
    if (data === 1 || data === "1") {
      return [1, 2, 3];
    }
  }
  if (nos) {
    return nos;
  }
  return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
};

export default function NewUser(props) {
  const { t } = useTranslation();
  const [deviceData, setDeviceData] = useState({});
  const [deviceConfig, setDeviceConfig] = useState({});
  const deviceTypes = [
    { id: 1, name: "Medibag" },
    { id: 2, name: "Sensor module" },
  ];
  const [companies, setCompanies] = useState();
  const [no_sensors, setNoSensors] = useState([1, 2, 3]);
  const dispatch = useDispatch();

  let getCompanies = () => {
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ token: getToken() }),
    };
    fetch(server + "/get_companies", requestOptions)
      .then((res) => res.json())
      .then((result) => {
        if (process.env.NODE_ENV !== "production") {
          console.log(result);
        }
        if (result.error) {
          dispatch(showPopupSnackbar(result));
        } else {
          setCompanies(result.companies);
        }
      });
  };

  function getCompanyID(c) {
    var a = companies.filter((comp) => {
      return comp.companyName === c;
    });
    return a[0].id;
  }

  function getDeviceTypeId(c) {
    var a = deviceTypes.filter((comp) => {
      return comp.name === c;
    });
    return a[0].id;
  }

  useEffect(() => {
    if (!companies) {
      getCompanies();
    }
  });

  function submitForm() {
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        deviceData: {
          ...deviceData,
        },
        deviceConfig: {
          ...deviceConfig,
        },
        token: getToken(),
      }),
    };
    fetch(server + "/create_new_device", requestOptions)
      .then((res) => res.json())
      .then((result) => {
        if (process.env.NODE_ENV !== "production") {
          console.log(result);
        }
        dispatch(showPopupSnackbar(result));
      });
  }

  return (
    <Grid container spacing={3}>
      {/* Device information */}
      <Grid item xs={12} sm={6}>
        <TextField
          name="serialNumber"
          variant="outlined"
          required
          fullWidth
          id="serialNumber"
          label={t("newDevice.serial")}
          autoFocus
          onChange={(e) =>
            setDeviceData({ ...deviceData, serialNumber: e.target.value })
          }
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          variant="outlined"
          fullWidth
          name="deviceName"
          label={t("newDevice.deviceName")}
          id="deviceName"
          onChange={(e) =>
            setDeviceData({ ...deviceData, deviceName: e.target.value })
          }
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        {deviceTypes ? (
          <Autocomplete
            id="combo-box2"
            options={deviceTypes}
            getOptionLabel={(option) => option.name}
            onInputChange={(event, newInputValue) => {
              setDeviceData({
                ...deviceData,
                deviceType: getDeviceTypeId(newInputValue),
              });
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                required
                fullWidth
                label={t("newDevice.deviceType")}
              />
            )}
          />
        ) : undefined}
      </Grid>
      <Grid item xs={12} sm={6}>
        {companies ? (
          <Autocomplete
            id="combo-box"
            options={companies}
            getOptionLabel={(option) => option.companyName}
            onInputChange={(event, newInputValue) => {
              setDeviceData({
                ...deviceData,
                CompanyId: getCompanyID(newInputValue),
              });
            }}
            //style={{ width: 300 }}
            renderInput={(params) => (
              <TextField
                {...params}
                label={t("newDevice.company")}
                variant="outlined"
              />
            )}
          />
        ) : undefined}
      </Grid>
      {/* Device config information */}

      <Grid item xs={12}>
        <Title>{t("deviceDetails.deviceConfig")}</Title>
      </Grid>
      {deviceData.deviceType === 1 ? (
        <React.Fragment>
          <Grid item xs={12} sm={6}>
            <TextField
              name="targetTempLow"
              variant="outlined"
              required
              fullWidth
              type="number"
              id="targetTempLow"
              label={t("deviceDetails.targetTempLow")}
              onChange={(e) => {
                setDeviceConfig({
                  ...deviceConfig,
                  targetTempLow: e.target.value,
                });
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              name="targetTempHigh"
              variant="outlined"
              required
              fullWidth
              type="number"
              id="targetTempHigh"
              label={t("deviceDetails.targetTempHigh")}
              onChange={(e) => {
                setDeviceConfig({
                  ...deviceConfig,
                  targetTempHigh: e.target.value,
                });
              }}
            />
          </Grid>
        </React.Fragment>
      ) : (
        <React.Fragment>
          <Grid item xs={12}>
            <TextField
              name="no_sensors"
              id="no_sensors"
              variant="outlined"
              type="number"
              label="No. Sensors"
              InputProps={{
                inputProps: { min: 1, max: 10, defaultValue: 3 },
              }}
              onChange={(e) => {
                var arr = [];
                var val = parseInt(e.target.value);
                if (val > 10 || val < 0) {
                  return;
                }
                for (var index = 1; index < val + 1; index++) {
                  arr.push(index);
                }
                setNoSensors(arr);
              }}
            ></TextField>
          </Grid>
        </React.Fragment>
      )}
      {getNumberOfSensors(deviceData.deviceType, no_sensors).map((idx) => (
        <Grid item xs={12}>
          <Grid container spacing={3} style={{ width: "100%" }}>
            <Grid item xs={12}>
              <Typography>{t("deviceDetails.sensor") + idx} </Typography>
            </Grid>
            <Grid item xs={3}>
              <TextField
                fullWidth
                name="sensorName"
                variant="outlined"
                required
                id={"sensorName" + idx}
                label={t("deviceDetails.id")}
                onChange={(e) => {
                  setDeviceConfig({
                    ...deviceConfig,
                    [`sensor${idx}`]: {
                      ...deviceConfig[`sensor${idx}`],
                      id: e.target.value,
                    },
                  });
                }}
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                fullWidth
                name="sensorName"
                variant="outlined"
                required
                id={"sensorName" + idx}
                label={t("deviceDetails.name")}
                onChange={(e) => {
                  setDeviceConfig({
                    ...deviceConfig,
                    [`sensor${idx}`]: {
                      ...deviceConfig[`sensor${idx}`],
                      name: e.target.value,
                    },
                  });
                }}
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                fullWidth
                name="alertTempLow"
                variant="outlined"
                required
                type="number"
                id={"alertTempLow" + idx}
                label={t("deviceDetails.alertTempLow")}
                onChange={(e) => {
                  setDeviceConfig({
                    ...deviceConfig,
                    [`sensor${idx}`]: {
                      ...deviceConfig[`sensor${idx}`],
                      alertLow: e.target.value,
                    },
                  });
                }}
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                fullWidth
                name="alertTempHigh"
                variant="outlined"
                required
                type="number"
                id={"alertTempHigh" + idx}
                label={t("deviceDetails.alertTempHigh")}
                onChange={(e) => {
                  setDeviceConfig({
                    ...deviceConfig,
                    [`sensor${idx}`]: {
                      ...deviceConfig[`sensor${idx}`],
                      alertHigh: e.target.value,
                    },
                  });
                }}
              />
            </Grid>
          </Grid>
        </Grid>
      ))}
      <Grid item xs={12}>
        <Button variant="outlined" onClick={submitForm}>
          <Typography>{t("newDevice.submit")}</Typography>
        </Button>
      </Grid>
    </Grid>
  );
}
